import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";


export const useLoginInfo = () => {
  const [userLoginInfo, setUserLoginInfo] = useState({}) as any;
  const history = useHistory();

  const checkUserLogin = () => {
    try {
      let getUserLoginInfo = JSON.parse(localStorage.getItem('userLoginInfo') as any) as any;
      setUserLoginInfo(getUserLoginInfo);
      return true;
    } catch (e) {
      localStorage.removeItem("userLoginInfo");
      history.replace('/');
    }
  }
  useEffect(() => {
    checkUserLogin();
    // eslint-disable-next-line
  }, [history]);



  return {
    userLoginInfo,
    checkUserLogin
  }
}